import React, { useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { IconButton, Menu, Tooltip } from '@mui/material';

interface RowActionCommonProps extends Table.DataRowProps {
  actions: {
    icon: React.ReactNode;
    title: string;
    onClick: (row: any) => void;
  }[];
}

const RowActionCommon: React.FC<RowActionCommonProps> = ({ tableRow, actions, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const row = tableRow.row; 

  const handleClickRow = (event: React.MouseEvent<HTMLElement>) => {
    const isInActionColumn = (event.target as HTMLElement).closest('[data-cell-action]');
    if (isInActionColumn) return;
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <Table.Row
      {...restProps}
      tableRow={tableRow}
      onClick={handleClickRow}
      style={{ cursor: 'pointer' }}
    >
      {restProps.children}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        PaperProps={{
          sx: {
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
            borderRadius: 1,
            padding: '4px 8px',
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
          },
        }}
      >
        {actions.map((action, index) => (
          <Tooltip key={index} title={action.title}>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(row);
                handleClose();
              }}
            >
              {action.icon}
            </IconButton>
          </Tooltip>
        ))}
      </Menu>
    </Table.Row>
  );
};

export default RowActionCommon;
